import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continueCta: 'Confirm my address',
    streetLabel: 'Home Address',
    title: {
      default: 'What is your personal address?',
      fill: 'Type your personal address',
      verify: 'Please verify your personal address',
    },
  },
  fr: {
    continueCta: 'Confirmer mon adresse',
    streetLabel: 'Adresse postale personnelle',
    title: {
      default: 'Quelle est votre adresse personnelle\u00A0?',
      fill: 'Saisissez votre adresse personnelle',
      verify: 'Veuillez vérifier votre adresse personnelle',
    },
  },
} as const);
